/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        subtitle: 'Unique dashboard designs',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'dashboards.project',
                title: 'Project',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-check',
                link : '/project'
            },
            {
                id   : 'dashboards.contracts',
                title: 'Contrats',
                type : 'basic',
                icon : 'heroicons_outline:calendar',
                link : '/contracts'
            },
            {
                id   : 'dashboards.organization',
                title: 'Organizations',
                type : 'basic',
                icon : 'heroicons_outline:office-building',
                link : '/organizations'
            },
            {
                id   : 'dashboards.organization',
                title: 'Équipe',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/team'
            },
            {
                id   : 'dashboards.device',
                title: 'Appareils',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/devices'
            },
            {
                id   : 'dashboards.technician',
                title: 'Technicians',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/technicians'
            },
            {
                id   : 'worksheet',
                title: 'Horaire',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/worksheet/worker'
            },
            {
                id   : 'reports',
                title: 'Rapports',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/worksheet/by-date'
            }
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const employeeNavigation: FuseNavigationItem[] = [
    {
        id   : 'worksheet',
        title: 'Horaire',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/worksheet/worker'
    },
    {
        id   : 'contracts',
        title: 'Contracts',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/contracts'
    }
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
